import _ from "lodash";
import { formatItem, formatTypes } from "../../../../global/common/dateFormatting";
import { gEnums } from "../../../../global/enums/globalEnums";
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "../../../../global/cnr/reducers/reducerHelpers/dispatchProps";
import { golfEnums } from "../../enums/golfEnums";
import { createGolfRoundMatchesPreview } from "../../removed/createGolfRoundMatches";

const addRoundType = (index, roundType, count) => {
  return {
    checked: true,
    key: index,
    selected: true,
    count,
    text: _.startCase(roundType),
    value: roundType,
  }
}

const rts = {
  handleAmmend_tournamentDetails: 'handleAmmend_tournamentDetails',
  handleCreate_golfRoundMatchesPreview: 'handleCreate_golfRoundMatchesPreview',
  // handleCreate_golfTournament: 'handleCreate_golfTournament',
  handleInit_golfTournament: 'handleInit_golfTournament',
  handleSet_golfRoundPreview: 'handleSet_golfRoundPreview',
  handleSet_tournamentPreview: 'handleSet_tournamentPreview',
  ...grts,
}

export const golfCreateReducer = (state, action) => {

  const { pathViews, golfParent_cls, tournamentDetails, golfEvent_state, golfTournament_state } = state
  const { type, dispatch, formData } = action

  const { details } = golfTournament_state ?? {}
  const { golfCourses, teams: teams_event } = golfEvent_state ?? {}

  const { handleSet_tournamentPreview, handleSet_golfRoundPreview } = golfCreateHandlers(dispatch)

  switch (type) {

    case rts.handleInit_golfTournament:
      const d = new Date()
      const dd = formatItem(formatTypes.date, d)
      const golfers = action.golfers_event
      const _golfers = {}

      if (golfers) {
        _.forEach(golfers, (golfer, key) => {
          const { firstName, lastName, _itemKey, handicapIndex } = golfer
          const _golfer = { _itemKey, key: _itemKey, golferKey: _itemKey, firstName, lastName, tournamentHandicapIndex: handicapIndex }
          _golfers[_itemKey] = _golfer
        })
      }

      let td = {
        startDate: dd,
        endDate: dd,
        teams: { ...action.teams_event },
        golfers: _golfers ? { ..._golfers } : {}

      }

      if (action.tournamentDetails) {
        td = { ...td, ...action.tournamentDetails }
      }

      return { ...state, tournamentDetails: td }

    // case rts.handleCreate_golfTournament:
    //   golfParent_cls.createGolfTournament(pathViews, {}, tournamentDetails, teams_event, action.previewOnly).then(res => {
    //     const { success, result } = res ?? {}
    //     handleSet_tournamentPreview(result, true)
    //   })
    //   // createGolfTournament(mainDb, paps_state, {}, tournamentDetails, teams_event, true, setTournamentPreview)
    //   return { ...state }

    case rts.handleCreate_golfRoundMatchesPreview:
      if (isRoundLineupReady(details)) {
        createGolfRoundMatchesPreview(golfTournament_state, action.golfRoundKey, action.addResults, handleSet_golfRoundPreview)
      } else {
        return { ...state, lineupsFetched: true, lineupsReady: false }
      }
      return { ...state }

    case rts.handleAmmend_tournamentDetails:
      const _td = { ...tournamentDetails, ...formData }
      if (_td.tournamentType) {
        switch (_td.tournamentType) {
          case gEnums.golfTournamentTypes.ryderCup2Day:
            _td.roundTypes = []
            _td.roundTypes.push(addRoundType('1', golfEnums.roundTypes.bestBall, 1))
            _td.roundTypes.push(addRoundType('0', golfEnums.roundTypes.alternateShot, 1))
            _td.roundTypes.push(addRoundType('2', golfEnums.roundTypes.singles, 1))
            break;
          case gEnums.golfTournamentTypes.ryderCup3Day:
            _td.roundTypes = []
            _td.roundTypes.push(addRoundType('0', golfEnums.roundTypes.alternateShot1, 1))
            _td.roundTypes.push(addRoundType('1', golfEnums.roundTypes.bestBall1, 1))
            _td.roundTypes.push(addRoundType('2', golfEnums.roundTypes.alternateShot2, 1))
            _td.roundTypes.push(addRoundType('3', golfEnums.roundTypes.bestBall2, 1))
            _td.roundTypes.push(addRoundType('4', golfEnums.roundTypes.singles, 1))
            break;
          default:
            break;
        }
      }
      if (_td.golfCourse && golfCourses) {
        const gc = golfCourses[_td.golfCourse]
        _td._golfCourse = gc
      }
      return { ...state, tournamentDetails: _td, rowIndex: action.rowIndex }

    case rts.handleSet_tournamentPreview:
      return { ...state, tournamentPreview: action.tournamentPreview, updating: false, showPreview: action.showPreview }

    case rts.handleSet_golfRoundPreview:
      const { previewResult } = action
      const { roundMatches } = previewResult ?? {}
      return { ...state, roundMatches: roundMatches, lineupsFetched: true, lineupsReady: true }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation })

    default:
      return { ...state }
  }
}

export const golfCreateHandlers = (dispatch) => {
  return {
    handleAmmend_tournamentDetails: (formData, rowIndex) => { dispatch({ type: rts.handleAmmend_tournamentDetails, dispatch, formData, rowIndex }) },
    handleCreate_golfRoundMatchesPreview: (golfRoundKey, addResults) => { dispatch({ type: rts.handleCreate_golfRoundMatchesPreview, dispatch, golfRoundKey, addResults }) },
    // handleCreate_golfTournament: (previewOnly) => { dispatch({ type: rts.handleCreate_golfTournament, dispatch, previewOnly }) },
    handleSet_golfRoundPreview: (previewResult) => { dispatch({ type: rts.handleSet_golfRoundPreview, dispatch, previewResult }) },
    handleSet_tournamentPreview: (tournamentPreview, showPreview) => { dispatch({ type: rts.handleSet_tournamentPreview, dispatch, tournamentPreview, showPreview }) },
    handleInit_golfTournament: (teams_event, golfers_event, tournamentDetails) => { dispatch({ type: rts.handleInit_golfTournament, dispatch, teams_event, golfers_event, tournamentDetails }) },
    ...responseHandlers(dispatch)
  }
}

export const golfCreateInitialState = (init_state) => {

  const { golfEvent_state } = init_state ?? {}
  const { teams: teams_event } = golfEvent_state ?? {}

  const golfTeam1_event = teams_event ? teams_event.team1 : {}
  const golfTeam2_event = teams_event ? teams_event.team2 : {}

  const golfTeam1Style = {
    backgroundColor: golfTeam1_event && golfTeam1_event.teamColor ? golfTeam1_event.teamColor : 'white',
    color: golfTeam1_event && golfTeam1_event.teamTextColor ? golfTeam1_event.teamTextColor : 'black',
  }

  const golfTeam2Style = {
    backgroundColor: golfTeam2_event && golfTeam2_event.teamColor ? golfTeam2_event.teamColor : 'white',
    color: golfTeam2_event && golfTeam2_event.teamTextColor ? golfTeam2_event.teamTextColor : 'black',
  }

  const golfStyles = {
    golfTeam1Style,
    neutralStyle: { backgroundColor: 'darkGrey', color: 'black' },
    golfTeam2Style,
  }

  return { ...init_state, golfStyles }
};

const isRoundLineupReady = (details) => {
  const { lineups } = details
  const { team1, team2 } = lineups ? lineups : {}
  let ready = true
  if (team1) {
    Object.keys(team1).forEach(lik => {
      const tli = team1[lik]
      if (tli) {
        tli.forEach(item => {
          if (_.isNull(item.groupNumber) || _.isNull(item.golferKey) || _.isNull(item.key) || _.isNull(item.position)) {
            ready = false
          }
        })
      }
    })
  }
  if (team2) {
    Object.keys(team2).forEach(lik => {
      const tli = team2[lik]
      if (tli) {
        tli.forEach(item => {
          if (_.isNull(item.groupNumber) || _.isNull(item.golferKey) || _.isNull(item.key) || _.isNull(item.position)) {
            ready = false
          }
        })
      }
    })
  }
  return ready
}